import React, { useState } from 'react';
import PrimarySelect from '../../../../../../common/components/PrimarySelect/PrimarySelect';
import { getUpdatedTextWithAttribute } from '@mm/state/helpers/attribute-picker-helpers';
import AttributePicker from '../../../../../../common/components/AttributePicker/AttributePicker';
import AttributeContainingTextInput from '../../../../../components/AttributeContainingTextInput/AttributeContainingTextInput';
import { useInputRef } from '../../../../../../common/widgets/common/use-input-ref';
import { isValidURL } from '@mm/state/helpers/connection-helpers';
import './EditRequestTypeAndURL.pcss';

import { ConnectionRequestType } from '@mm/state/model/ConnectionModel';
import { REQUEST_TYPE_OPTIONS } from '@mm/stateful-components/EditConnectionPanel/constants';

type Props = {
  url: string;
  requestType: ConnectionRequestType;
  onRequestTypeChange: (requestType: ConnectionRequestType) => void;
  onUrlChange: (url: string) => void;
};

const EditRequestTypeAndURL = ({
  url,
  requestType,
  onRequestTypeChange,
  onUrlChange,
}: Props) => {
  const [localURL, setLocalURL] = useState(url);
  const { inputRef: urlInputRef, memoizedSetInputRef: setUrlInputRef } =
    useInputRef(false);

  const onAttributePicked = (attribute: string) => {
    const nextURL = getUpdatedTextWithAttribute(url, attribute, urlInputRef);

    setLocalURL(nextURL);

    setTimeout(() => {
      if (urlInputRef) {
        urlInputRef.focus();
      }
    }, 100);
  };

  return (
    <div className="edit-request-type-and-url">
      <div className="edit-request-type-and-url__title-row">
        <div className="edit-request-type-and-url__col1">
          <div className="edit-connection-panel__title">Request type</div>
          <PrimarySelect
            options={Object.values(REQUEST_TYPE_OPTIONS)}
            value={REQUEST_TYPE_OPTIONS[requestType]}
            onChange={requestType =>
              onRequestTypeChange(requestType.id as ConnectionRequestType)
            }
            customDropdownStyles={{ zIndex: '1000003' }}
          />
        </div>

        <div className="edit-request-type-and-url__col2">
          <div className="edit-connection-panel__title">
            URL
            {!isValidURL({ url }) && (
              <span className="edit-connection-panel__star">*</span>
            )}
          </div>
          <div>
            <AttributeContainingTextInput
              className="edit-request-type-and-url__url-input"
              placeholder="URL"
              onChange={e => setLocalURL(e.target.value)}
              value={localURL}
              onBlur={() => onUrlChange(localURL)}
              inputRef={setUrlInputRef}
              useStoreAttributes
            />
            <div className="edit-request-type-and-url__url-note-wrapper">
              <div className="edit-request-type-and-url__note">
                Variables in urls are URL encoded
              </div>
              <AttributePicker
                className="edit-request-type-and-url__attribute-picker"
                onAttributePicked={onAttributePicked}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditRequestTypeAndURL;
